export function Logo({ className = "" }: { className?: string }) {
  return (
    <img
      src="/images/majourneys-logo-light.svg"
      alt="MaJourneys"
      className={`h-8 ${className}`}
    />
  );
}
